import { UnitSystem, unitSystems } from "containers/NewProject/NewProject";

export const trimText = (text: string, length = 20) => {
  return text.length > length ? `${text.slice(0, length)}...` : text;
};

/**
 * Checks whether a string is a valid JSON string or not
 * @param {String} string string to be validated
 * @returns boolean
 */
export function isValidJSON(string: string) {
  try {
    JSON.parse(string);
  } catch {
    return false;
  }

  return true;
}

/**
 * all this function does is
 * if the string is enclosed in double quotes, take them out
 * else return it as it is
 * @param string the string to be parsed
 * @returns string -> the parsed string
 */
export function parseString(string: string) {
  return isValidJSON(string) ? JSON.parse(string) : string;
}

const areaUnitConverter = (value: number, unit: UnitSystem, toUnit: UnitSystem) => {
  if (unit === toUnit) {
    return value;
  }

  if (unit === 'imperial' && toUnit === 'metric') {
    return value * 0.092903;
  }

  if (unit === 'metric' && toUnit === 'imperial') {
    return value * 10.7639;
  }

  return value;
}

export const formatRangeAsText = (min: number | null, max: number | null, unit: UnitSystem, toUnit: UnitSystem) => {
  
  // ? I know these checks are stupid but its just cuz typescript 
  // ? had a hard time figuring out when min and max are not null
  
  if (!min && !max) {
    return null;
  }

  if (!min && max) {
    return `Up to ${areaUnitConverter(max, unit, toUnit)?.toLocaleString('en-US')} ${unitSystems[toUnit]}`;
  } 

  if (!max && min) {
    return `At least ${areaUnitConverter(min, unit, toUnit)?.toLocaleString('en-US')} ${unitSystems[toUnit]}`;
  }

  if (min && max) {
    return `${areaUnitConverter(min, unit, toUnit)?.toLocaleString('en-US')} - ${areaUnitConverter(max, unit, toUnit)?.toLocaleString('en-US')} ${unitSystems[toUnit]}`;
  }

  return null;
};
